import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface CareersBentoCtaProps {
  label: string;
  className?: string;
  size?: "default" | "sm";
  /** Scale the pill with cqw when the tile is a proportionally-sized grid cell. */
  scaled?: boolean;
}

/**
 * Careers CTA inside the about-us bento grid (Figma 5198:44519). Reuses the
 * shared gradient-secondary-shadow glow in an always-on orbit behind a
 * standard secondary pill — the surrounding card link is the interactive target.
 */
export function CareersBentoCta({
  label,
  className,
  size = "default",
  scaled = false,
}: CareersBentoCtaProps) {
  return (
    <Button
      variant="secondary-gradient-shadow-always-on"
      size={size}
      nativeButton={false}
      render={<span />}
      className={cn(
        "pointer-events-none relative",
        scaled
          ? "lg:text-ds-body-sm min-w-[37.132cqw] lg:h-[38px] lg:px-4"
          : "min-w-0 px-2.5",
        className
      )}
    >
      <span className="relative z-[1]">{label}</span>
    </Button>
  );
}
